import React from 'react';
import Loader from 'react-loader-spinner';

const PageLoader = () => {
  return (
    <div className="flex justify-center items-center mt-1">
      <Loader color="#424242" height={20} type="Oval" width={20} />
    </div>
  );
};

export default PageLoader;
